/* eslint-disable prefer-const */
import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

import {updateObject} from 'utils/reducerUtils';
import {isTablet} from 'react-device-detect';
import AudioPlayer from 'components/AudioPlayer';

import audioFilesNo from './languages/no-audioFiles-norming';
import audioFilesNn from './languages/nn-audioFiles-norming';

import nnAnswers from './languages/nnAnswers-norming.json';
import noAnswers from './languages/noAnswers-norming.json';
import audioFilesNoUpperGrades from './languages/no-audioFilesUpper-norming';
import audioFilesNnUpperGrades from './languages/nn-audioFilesUpper-norming';
import assignmentsObject from './languages/normingData.json';
import strings from 'utils/strings';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faVolumeHigh} from '@fortawesome/free-solid-svg-icons';

const audioFilesLowerGradeObj = {
	no: audioFilesNo,
	nn: audioFilesNn,
};
const audioFilesUpperGradeObj = {
	no: audioFilesNoUpperGrades,
	nn: audioFilesNnUpperGrades,
};

const testAnswerObj = {
	no: noAnswers,
	nn: nnAnswers,
};
const maxAudioPlayCount = 2;
const CONSECUTIVE_FAILURE_STOP_THRESHOLD = 6;
class Norming extends React.Component {
	constructor(props) {
		super(props);
		const selectedLanguage = strings.getLanguage() || 'no';
		this.audioFiles =
			this.props.candidateGrade < 5
				? audioFilesLowerGradeObj[selectedLanguage]
				: audioFilesUpperGradeObj[selectedLanguage];

        this.answers = testAnswerObj[selectedLanguage];
        this.assignments =
			this.props.candidateGrade < 5
				? assignmentsObject['lower']
				: assignmentsObject['upper'];
        
		const results = {};

		for (const assignment of this.assignments) {
			results[assignment.id] = assignment.value;
		}

		this.state = {
			results,
			disabledAssignments: {},
			visitedAssignments: {},
			audioPlayCounts: {},
			bruteFinish: false,
			showWordAudio: false,
			currentClickedIndex: null,
			showChoiceAudio: false,
			currentChoiceIndex: null,
			showQuestionPlayButton: true,
			showChoicePlayButton: true,
		};
	}

	setResults(id, value) {
		const {results, visitedAssignments} = this.state;

		this.setState(
			{
				results: updateObject(results, {
					[id]: value,
				}),
				visitedAssignments: updateObject(visitedAssignments, {
					[id]: true,
				}),
			},
			() => {
				this.checkForConsecutiveMistake(id);
			}
		);
	}

	markAssignmentVisited(id) {
		const {visitedAssignments} = this.state;
		this.setState(
			{
				visitedAssignments: updateObject(visitedAssignments, {
					[id]: true,
				}),
			},
			() => {
				this.checkForConsecutiveMistake(id);
			}
		);
	}

	normalizeAnswer(value) {
		return String(value || '').trim().toLowerCase();
	}

	getAcceptedAnswers(assignmentId) {
		const answer = this.answers.find(({id}) => id === assignmentId);
		const answerKey =
			this.props.candidateGrade < 5 ? 'value' : 'upperGradeValue';
		const altKey =
			this.props.candidateGrade < 5
				? 'valueAltValues'
				: 'upperGradeAltValues';

		if (!answer || !answer[answerKey]) {
			return [];
		}

		return [answer[answerKey], ...(answer[altKey] || [])].map((value) =>
			this.normalizeAnswer(value)
		);
	}

	isCorrectAnswer(assignmentId, value) {
		const normalizedValue = this.normalizeAnswer(value);
		const acceptedAnswers = this.getAcceptedAnswers(assignmentId);

		return (
			normalizedValue !== '' && acceptedAnswers.includes(normalizedValue)
		);
	}

	checkForConsecutiveMistake(id) {
		const {results, visitedAssignments} = this.state;
		const assignmentIndex = this.assignments.findIndex(
			(assignment) => assignment.id === id
		);
		const assignmentsToCheck =
			assignmentIndex === -1
				? this.assignments
				: this.assignments.slice(0, assignmentIndex + 1);
		let consecutiveFailures = 0;

		for (const assignment of assignmentsToCheck) {
			if (!visitedAssignments[assignment.id]) {
				continue;
			}

			const acceptedAnswers = this.getAcceptedAnswers(assignment.id);
			if (acceptedAnswers.length === 0) {
				continue;
			}

			consecutiveFailures = this.isCorrectAnswer(
				assignment.id,
				results[assignment.id]
			)
				? 0
				: consecutiveFailures + 1;

			if (consecutiveFailures >= CONSECUTIVE_FAILURE_STOP_THRESHOLD) {
				this.setState({
					bruteFinish: true,
				});
				break;
			}
		}
	}

	getDisabledAssignments() {
		const {results} = this.state;

		const disabledAssignments = {};
		for (let i = 0; i < this.assignments.length; i++) {
			const assignmentId = this.assignments[i].id;
			if (results[assignmentId]) {
				disabledAssignments[assignmentId] = true;
			}
		}
		return disabledAssignments;
	}

	render() {
		const {onNextStep, refs, isSendingTestResults} = this.props;

		const {audioPlayCounts,disabledAssignments, results} = this.state;

		 const allResultsHasValues = Object.keys(results).every((key) => results[key]);
    	const isNextButtonVisible = allResultsHasValues;

		return (
			<div className="lit-wrapper--thin lit-test lit-diktat lit-norming">
				{!this.state.bruteFinish &&
					!isTablet &&
					this.assignments.map((assignment) => {
						const assignmentId = assignment.id;
						const audioFile = this.audioFiles[assignmentId];
						const assignmentAudioPlayCount =
							audioPlayCounts[assignmentId] || 0;
						const isDisabled = disabledAssignments[assignmentId];
						const isAudioDisabled =
							isDisabled ||
							assignmentAudioPlayCount === maxAudioPlayCount;

						let audioPlayerRef;
						return (
							<div
								className={classNames(
									'lit-input lit-revealed',
									{
										'lit-input--disabled': isDisabled,
									}
								)}
								key={assignmentId}
							>
								<AudioPlayer
									strokeColor="#051949ff"
					
									disabled={isAudioDisabled}
									id={assignmentId}
									onErrorPlay={() => {
										console.log('Something went wrong');
										this.setState({
											showQuestionPlayButton: true,
											currentClickedIndex: null,
											showChoicePlayButton: true,
											audioPlayCounts: updateObject(
												audioPlayCounts,
												{
													[assignmentId]:
														assignmentAudioPlayCount -
														1,
												}
											),
										});
									}}
									onStart={() => {
										this.setState({
											audioPlayCounts: updateObject(
												audioPlayCounts,
												{
													[assignmentId]:
														assignmentAudioPlayCount +
														1,
												}
											),
										});
									}}
									ref={(ref) => {
										audioPlayerRef = ref;
									}}
									refs={refs}
									src={audioFile}
								/>
								<input
									className="lit-input__field"
									disabled={isDisabled}
									placeholder={strings.writeWordHere}
									  spellCheck={false}
  autoComplete="off"
  autoCorrect="off"
  autoCapitalize="off"
  inputMode="text"
  aria-autocomplete="none"
  enterKeyHint="done"
  data-gramm="false"
  data-enable-grammarly="false"
  name={`norming-${assignmentId}`}
  type="text"
									onChange={(ev) => {
										if (isDisabled) {
											return;
										}
										const value = ev.target.value;
										if (value.trim() !== '')
											this.setResults(
												assignmentId,
												value
											);
									}}
									onFocus={() => {
										const disabledAssignments =
											this.getDisabledAssignments();
										disabledAssignments[
											assignmentId
										] = false;

										if (assignmentAudioPlayCount === 0) {
											audioPlayerRef.handleStartPlayer();
										}

										this.setState({
											disabledAssignments,
										});
									}}
									onBlur={() => {
										this.markAssignmentVisited(
											assignmentId
										);
									}}
									/* onClick={() => {
										this.checkForConsecutiveMistake(
											assignmentId
										);
									}}
									onKeyUp={(e) => {
										if (
											e.keyCode === 9 ||
											e.code === 'Tab'
										) {
											this.checkForConsecutiveMistake(
												assignmentId
											);
										}
									}} */
								/>
							</div>
						);
					})}

				{/* Creating new view for Tablets */}

				{!this.state.bruteFinish &&
					isTablet &&
					this.assignments.map((assignment, index) => {
						const assignmentId = assignment.id;
						const mainIndex = index + 1;
						const audioFile = this.audioFiles[assignmentId];
						const assignmentAudioPlayCount =
							audioPlayCounts[assignmentId] || 0;
						const isDisabled = disabledAssignments[assignmentId];
						const isAudioDisabled =
							isDisabled ||
							assignmentAudioPlayCount === maxAudioPlayCount;

						let audioPlayerRef;
						return (
							<div
								style={{
									display: 'flex',
									marginTop: '15px',
								}}
								className={classNames(
									'lit-input lit-revealed',
									{
										'lit-input--disabled': isDisabled,
									}
								)}
								key={assignmentId}
							>
								<div
									className=""
									style={{
										height: '50px',
										width: '50px',
										marginRight: '20px',
									}}
								>
									{this.state.showQuestionPlayButton && (
										<FontAwesomeIcon
											className={
												!isAudioDisabled
													? 'lit-play-button-ordiktat'
													: 'lit-play-button-ordiktat-disabled '
											}
											size="lg"
											icon={faVolumeHigh}
											onClick={() => {
												if (!isAudioDisabled) {
													this.setState({
														showWordAudio: true,
														showQuestionPlayButton: false,
														currentClickedIndex:
															mainIndex,
														showChoicePlayButton: false,
													});
												}
											}}
										/>
									)}
									{!this.state.showQuestionPlayButton &&
										this.state.currentClickedIndex !==
											mainIndex && (
											<FontAwesomeIcon
												size="lg"
												className="lit-play-button-ordiktat-disabled"
												icon={faVolumeHigh}
											/>
										)}
									{this.state.showWordAudio &&
										this.state.currentClickedIndex ===
											mainIndex && (
											<div>
												<AudioPlayer
												strokeColor="#f4e807ff"
												outlineColor="#333434ff"
													disabled={isAudioDisabled}
													id={assignmentId}
													autoplay
													onErrorPlay={() => {
														console.log(
															'Something went wrong'
														);
														this.setState({
															showQuestionPlayButton: true,
															currentClickedIndex:
																null,
															showChoicePlayButton: true,
															audioPlayCounts:
																updateObject(
																	audioPlayCounts,
																	{
																		[assignmentId]:
																			assignmentAudioPlayCount -
																			1,
																	}
																),
														});
													}}
													onComplete={() => {
														this.setState({
															showQuestionPlayButton: true,
															currentClickedIndex:
																null,
															showChoicePlayButton: true,
														});
													}}
													onStart={() => {
														this.setState({
															audioPlayCounts:
																updateObject(
																	audioPlayCounts,
																	{
																		[assignmentId]:
																			assignmentAudioPlayCount +
																			1,
																	}
																),
														});
													}}
													ref={(ref) => {
														audioPlayerRef = ref;
													}}
													refs={refs}
													src={audioFile}
												/>{' '}
											</div>
										)}
								</div>
								<input
									className="lit-input__field"
									disabled={isDisabled}
									placeholder={strings.writeWordHere}
									spellCheck={false}
  autoComplete="off"
  autoCorrect="off"
  autoCapitalize="off"
  inputMode="text"
  aria-autocomplete="none"
  enterKeyHint="done"
  data-gramm="false"
  data-enable-grammarly="false"
  name={`norming-${assignmentId}`}
  type="text"
									onChange={(ev) => {
										if (isDisabled) {
											return;
										}
										const value = ev.target.value;
										if (value.trim() !== '')
											this.setResults(
												assignmentId,
												value
											);
									}}
									onFocus={() => {
										const disabledAssignments =
											this.getDisabledAssignments();
										disabledAssignments[
											assignmentId
										] = false;

										/* if (assignmentAudioPlayCount === 0) {
											audioPlayerRef.handleStartPlayer();
										} */
										if (!isAudioDisabled) {
											this.setState({
												showWordAudio: true,
												showQuestionPlayButton: false,
												currentClickedIndex: mainIndex,
												showChoicePlayButton: false,
											});
										}

										this.setState({
											disabledAssignments,
										});
									}}
									onBlur={() => {
										this.markAssignmentVisited(
											assignmentId
										);
									}}
									onClick={() => {
										this.checkForConsecutiveMistake(
											assignmentId
										);
									}}
									onKeyUp={(e) => {
										if (
											e.keyCode === 9 ||
											e.code === 'Tab'
										) {
											this.checkForConsecutiveMistake(
												assignmentId
											);
										}
									}}
								/>
							</div>
						);
					})}
				{(isNextButtonVisible || this.state.bruteFinish) && (
					<button
						className="lit-btn lit bg-primary"
						onClick={() => onNextStep(results)}
						disabled={isSendingTestResults}
					>
						{strings.done}
					</button>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {
		testStepAnswers: {isSendingTestResults},
	} = state;

	return {
		isSendingTestResults,
	};
};

export default connect(mapStateToProps)(Norming);
